<template lang="pug">
    .md-content
        PmBreadcrumbs(:view="lenguageNavSelected.breadcrumb", :section="section", :lang="lenguage")
        PmBanner(:name="lenguageNavSelected.title", :image="banner")
        PmContentBox(:content="lenguageNavSelected.box")
        .container
            .row
                .col-md-4
                    PmSidebar(:options="lenguageNavSelected.nav", :contact="true", :lang="lenguage")
                .col-md-8
                    transition(name="fade", mode="out-in")
                        router-view 

</template>

<script>
import PmBreadcrumbs from '@components/atoms/PmBreadCrumbs.vue'
import PmBanner from '@components/atoms/PmBanner.vue'
import PmContentBox from '@components/atoms/PmContentBox.vue'
import PmSidebar from '@components/atoms/PmSidebar.vue'

import municipalitiesBanner from '@img/municipalities/Banner_MUNICIPALITIES.jpg'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    components: {
        PmBreadcrumbs, PmBanner, PmContentBox, PmSidebar
    },
    mounted: function(){
        this.$data.section = this.$route.name;
        let to = this.moveToDown
        ? this.$refs.description.offsetTop - 60
        : 0

    window.scroll({
        top: to,
        left: 0,
        behavior: 'smooth'
    })

    this.moveToDown = !this.moveToDown
    },
    data: function(){
        return{
            lenguage: 'EN',
            enContent: {
                nav: [
                    {name:"Smart Cities", path: "/en/municipalities/smart-cities", isactive: true},
                    {name:"Internet of Things", path: "/en/municipalities/smart-cities", isactive: true},
                    {name:"Public Safety", path: "/en/municipalities/smart-cities", isactive: true}
                ],
                box: 'Our reputation is important to us, and it shows in everything we do. With our well-positioned sites and networks, our collaborative approach, and our experienced management team, ATP understands how to deliver on our clients’ needs.',
                title: 'MUNICIPALITIES',
                breadcrumb: {name:'Municipalities', link:'/en/municipalities/smart-cities'},
            },
            esContent: {
                nav: [
                    {name:"Ciudades Inteligentes", path: "/es/municipios/ciudades-inteligentes", isactive: true},
                    {name:"Internet of Things (IoT)", path: "/es/municipios/ciudades-inteligentes", isactive: true},
                    {name:"Seguridad Pública", path: "/es/municipios/ciudades-inteligentes", isactive: true}
                ],
                box: 'Cuidamos nuestra reputación, y esto se muestra en todo lo que hacemos. Con las excelentes ubicaciones de nuestro portafolio de sitios y redes, nuestro enfoque colaborativo, y nuestro experimentado equipo directivo, sabemos cómo satisfacer las necesidades de nuestros clientes y como trabajar con municipios en la construcción de las ciudades inteligentes del futuro.',
                title: 'MUNICIPIOS',
                breadcrumb: {name:'Municipios', link:'/es/municipios/ciudades-inteligentes'},
            },
            banner: municipalitiesBanner,
            
            section: ''
        }
    },
    computed: {
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.enContent : this.$data.esContent
        }
    },
}
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components/organisms/PmMunicipalities.vue